export const getComparison = (card, data) => {
  const sumValues = (valuesObject) => {
    return Object.values(valuesObject).reduce((acc, value) => acc + value, 0);
  };

    const otherCard = data.find(
      (c) =>
        c.retirementType === card.retirementType &&
        c.benefitType === card.benefitType &&
        c.remedyChoice !== card.remedyChoice
    );
    if (otherCard) {
      const difference = sumValues(card.values) - sumValues(otherCard.values);
      const comparison = difference > 0 ? "higher" : difference < 0 ? "lower" : "equal";
      return [comparison, otherCard.remedyChoice, Math.abs(difference)];
    }
    return null;
  };